import { isFilterVisibleInContext } from "../../../components/common/Dashboard/utils";
import { FilterContexType } from "../../../components/layout/ViewHeader";
import { DashboardFilterInstance, FilterDefinition, FiltersRegistry } from "../types";

// Result of joining runtime instance + registry definition
export type DashboardFilterResolved = {
	instance: DashboardFilterInstance;
	filter: FilterDefinition;
	isAvailable?: boolean;
};

// Resolves dashboard filter instances into full filter definitions
// by joining them with the registry (by filterId)
export const getDashboardFilters = (
	registry: FiltersRegistry | null,
	dashboardFilters: DashboardFilterInstance[],
	context?: FilterContexType
): DashboardFilterResolved[] => {
	if (!registry) return [];

	return dashboardFilters
		.map((instance) => {
			const filter = registry.byId[instance.filterId];

			if (!filter) return null;

			return {
				instance,
				filter,
				isAvailable: isFilterVisibleInContext(filter.field?.visibility ?? filter.visibility, context),
			};
		})
		.filter(Boolean) as DashboardFilterResolved[];
};

// Checks if there are any active dashboard filters
// or if advanced mode is enabled
export const hasDashboardFilters = (dashboardFilters: DashboardFilterInstance[], advancedMode: boolean): boolean => {
	return dashboardFilters.length > 0 || advancedMode;
};
